// Hash-based routing. The SPA is served from a single CloudFront origin with
// 403/404 rewritten to index.html, so the path after `#/` is the only client
// route. Query string after the path is preserved (login ?returnTo=).

export const VIEWS = ["dashboard", "logs", "chat", "reports", "spend", "settings"] as const;
export type View = (typeof VIEWS)[number];

export type Route =
  | { kind: "login"; returnTo: string }
  | { kind: "app"; view: View };

function isView(raw: string): raw is View {
  return (VIEWS as readonly string[]).includes(raw);
}

export function parseHash(hash = location.hash): Route {
  const raw = hash.replace(/^#\/?/, "");
  const q = raw.indexOf("?");
  const path = (q === -1 ? raw : raw.slice(0, q)).toLowerCase();
  const search = new URLSearchParams(q === -1 ? "" : raw.slice(q + 1));

  if (path === "login") {
    const returnTo = search.get("returnTo") || "/dashboard";
    return { kind: "login", returnTo: returnTo.startsWith("/") ? returnTo : `/${returnTo}` };
  }
  return { kind: "app", view: isView(path) ? path : "dashboard" };
}

export function hashForLogin(returnTo: string): string {
  const path = returnTo.startsWith("/") ? returnTo : `/${returnTo}`;
  const safe = path.startsWith("/login") ? "/dashboard" : path;
  return `#/login?returnTo=${encodeURIComponent(safe)}`;
}

export function hashForView(view: View): string {
  return `#/${view}`;
}
